import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';

export function ClientConfirmDialog({
  open,
  title = 'Confirmar operación',
  message,
  confirmText = 'Confirmar',
  loading = false,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog className="client-confirm-dialog" open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
      <div className="client-confirm-dialog__icon"><HelpOutlineRoundedIcon /></div>
      <DialogTitle className="client-confirm-dialog__title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText className="client-confirm-dialog__message">{message}</DialogContentText>
      </DialogContent>
      <DialogActions className="client-confirm-dialog__actions">
        <Button className="client-confirm-dialog__cancel" onClick={onCancel} disabled={loading} color="inherit">Cancelar</Button>
        <Button className="client-confirm-dialog__confirm" onClick={onConfirm} disabled={loading} variant="contained">
          {loading ? 'Procesando...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
